import { render } from "./OperationDetail.vue?vue&type=template&id=44174082&scoped=true&ts=true"
import script from "./OperationDetail.vue?vue&type=script&lang=ts"
export * from "./OperationDetail.vue?vue&type=script&lang=ts"

import "./OperationDetail.vue?vue&type=style&index=0&id=44174082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44174082"]])

export default __exports__